var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{class:{ 'mt-0': !_vm.isAVRMobile }},[_vm._v(_vm._s(_vm.title))]),(_vm.text)?_c('p',[_vm._v(_vm._s(_vm.text))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }